<template>
    <div>
        <!-- Insert/Edit Modal -->
        <b-modal ref="createSource" id="createSource" class="add-edit-modal" size="xl"  @show="onShowModal" @hide="onHideModal" top hide-header hide-header-close centered scrollable>
            <b-row class="m-3" v-loading="!isLoaded" :element-loading-text="$t('sourceInfoLoading')">
                <b-col md="2" class="mt-2">
                    <el-steps :space="60" :active="activeStep" finish-status="success" direction="vertical">
                        <el-step v-for="(step,index) in steps" :key="index" :title="modalType == 'insert' ? $t(step.stepTitle) : $t(step.editStepTitle)"></el-step>
                    </el-steps>
                </b-col>
                <b-col md="10" style="color: #022b49;" >
                    <template v-if="steps[activeStep].stepTitle == 'selectActivity'">
                        <b-row class="mb-5">
                            <span class="stepSubTitle">{{ modalType == 'insert' ? $t(steps[activeStep].stepSubTitle) : $t(steps[activeStep].editStepSubTitle) }}</span>
                        </b-row>
                        <b-row style="overflow-y:auto;overflow-x:hidden;">
                            <b-card-group >
                                <div v-for="(scopeGroup, key) in scopeGroups" 
                                    :key="scopeGroup.id"
                                    class="col-sm-6 col-lg-3 py-3"
                                >
                                    <b-card 
                                        style="text-align:center;height:150px;"
                                        :style="modalType=='insert'?'cursor:pointer':''"
                                        @click="selectScopeGroup(scopeGroup, key)"
                                        :class="['d-flex',{'is-selected': scopeGroup.isSelected}]"
                                    >
                                    <b-row align-h="center" :key="`${key}-${activeStep}`">
                                        <i :class="scopeGroup.icon+' fa-3x'" style="color:#AAABB9"></i>
                                    </b-row>
                                    <b-row align-h="center">
                                        <b-card-text>
                                            <span>{{$t(scopeGroup.name)}}</span>
                                        </b-card-text>
                                    </b-row>
                                    </b-card>
                                </div>
                            </b-card-group>
                        </b-row>
                    </template>
                    <!-- Sources -->
                    <template v-else-if="steps[activeStep].stepTitle == 'defineSources'">
                        <b-row class="mb-5" v-if="modalType == 'insert'">
                            <span class="stepSubTitle">{{ $t(steps[activeStep].stepSubTitle)  }}</span>
                        </b-row>
                        <b-row class="mb-4" style="justify-content:space-between" v-else>
                            <div>
                                <span class="stepSubTitle">{{ $t(steps[activeStep].editStepSubTitle) }}</span>
                            </div>
                            <!-- Delete -->
                            <div>
                                <b-btn v-if="modalType == 'update'" class="delete-button" @click="openSourceDeleteModal(editedItem.id)"><i class="fas fa-trash-alt"></i></b-btn>
                            </div>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-row class="mb-4" v-if="modalType == 'update'">
                                    <!-- Active/Passive -->
                                    <label for="enabled-checkbox" class="formTitle pr-2"> {{$t('enabled')}}</label>
                                    <b-form-checkbox
                                        v-model="editedItem.isActive"
                                        name="enabled-checkbox"
                                        id="enabled-checkbox"
                                        :value="true"
                                        :unchecked-value="false"
                                        class="checkbox"
                                    >
                                    </b-form-checkbox>
                                </b-row>
                                <b-row class="section-line">
                                    <b-col md="5">
                                        <b-row>
                                            <span class="formTitle">{{ $t('sourceName')}}</span>
                                        </b-row>
                                        <b-row style="width: 85%">
                                            <!-- Source Name -->
                                            <b-form-input
                                                class="my-1"
                                                v-model="editedItem.name"
                                                style="height:10%;padding: 5px 10px;"
                                                :placeholder="$t('writeSourceName')"
                                                @input="forceUpdate"/>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="section-line">
                                    <b-col>
                                        <b-row class="mt-3">
                                            <b-col v-if="isSourceTypeGroupAvailable()" md="5" style="margin-right: 50px">
                                                <b-row>
                                                    <span class="formTitle">
                                                        {{ $t(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroupsHeader) }}
                                                    </span>
                                                </b-row>
                                                <b-row>
                                                    <!-- Source Type Group -->
                                                    <b-form-select 
                                                        class="my-1" 
                                                        v-model="editedItem.sourceTypeGroup" 
                                                        :options="arrangeOptions(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups)"
                                                        @change="forceUpdate"
                                                         >
                                                    </b-form-select>
                                                </b-row>
                                            </b-col>
                                            <b-col md="5">
                                                <b-row>
                                                    <span class="formTitle">{{ $t('type')}}</span>
                                                </b-row>
                                                <b-row>
                                                    <!-- Source Type Group -->
                                                    <b-form-select 
                                                        class="my-1" 
                                                        v-model="editedItem.sourceType" 
                                                        :options="editedItem.sourceTypeGroup == null ? 
                                                        []:
                                                        arrangeOptions(this.scopeGroups[this.editedItem.scopeGroup].sourceTypes[editedItem.sourceTypeGroup], true)" 
                                                        :disabled="!editedItem.sourceTypeGroup && isSourceTypeGroupAvailable()"
                                                        @change="forceUpdate"
                                                    >
                                                    </b-form-select>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                        <b-row class="my-3">
                                            <b-col md="3" style="margin-right: 50px">
                                                <b-row>
                                                    <span class="formTitle">{{ $t('unit') }}</span>
                                                </b-row>
                                                <b-row>
                                                    <!-- Unit -->
                                                    <b-form-select 
                                                        class="my-1" 
                                                        v-model="editedItem.unit"
                                                        :options="editedItem.sourceType == null ?
                                                        []:
                                                        arrangeOptions(this.sourceTypes[editedItem.sourceType].units)"
                                                        :disabled="!editedItem.sourceType"
                                                        @change="selectUnit"
                                                    >
                                                    </b-form-select>
                                                </b-row>
                                            </b-col>
                                            <b-col md="4" style="margin-right: 30px">
                                                <b-row>
                                                    <span class="formTitle" style="font-size:.8em;">{{ $t('normalizationType') }}</span>
                                                </b-row>
                                                <b-row>
                                                    <!-- Normailzation -->
                                                    <b-form-select 
                                                        class="my-1" 
                                                        v-model="editedItem.normalizationType">
                                                        <option 
                                                            v-for="normalization in normalizationTypes" 
                                                            v-bind:ref="'normalization'" 
                                                            :value="normalization" 
                                                            :key="`normalization-${normalization}`">
                                                            {{ $t(normalization) }}
                                                        </option>
                                                    </b-form-select>
                                                </b-row>
                                            </b-col>
                                            <b-col md="2" v-if="scopeGroups[editedItem.scopeGroup].hazardous" style="padding-top:30px;">
                                                <b-row>
                                                    <!-- Hazardous -->
                                                    <b-form-checkbox
                                                        v-model="editedItem.hazardous"
                                                        name="checkbox-2"
                                                        :value="true"
                                                        :unchecked-value="false"
                                                        class="checkbox"
                                                    >
                                                        <span class="formTitle">
                                                            {{ $t('hazardous') }} 
                                                        </span>
                                                    </b-form-checkbox>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <!--
                                <b-row class="my-3">
                                    <b-col md="5">
                                        <b-row>
                                            <span class="formTitle">{{ $t('validFrom') }}</span>
                                        </b-row>
                                        <b-row  style="width: 70%">
                                            <span>
                                                {{editedItem.validFrom}}
                                            </span>
                                            <el-date-picker
                                                :placeholder="$t('chooseDatePlaceholder')"
                                                v-model="editedItem.validFrom"
                                                type="month"
                                                format="MM/yyyy"
                                                style="width: 100%;"
                                                class="my-1 input-border"
                                            />
                                        </b-row>
                                    </b-col>
                                    <b-col md="5" v-if="modalType == 'update'">
                                        <b-row>
                                            <span class="formTitle">{{ $t('until') }}</span>
                                        </b-row>
                                        <b-row  style="width: 70%">
                                            <el-date-picker
                                                :placeholder="$t('chooseDatePlaceholder')"
                                                v-model="editedItem.until"
                                                type="month"
                                                format="MM/yyyy"
                                                style="width: 100%;"
                                                class="my-1 input-border"
                                            />
                                        </b-row>
                                    </b-col>
                                </b-row>
                                -->
                            </b-col>
                        </b-row>
                    </template>
                    <template v-else-if="steps[activeStep].stepTitle == 'assignLocations'">
                        <b-row class="mb-5">
                            <span class="stepSubTitle">{{ modalType == 'insert' ? $t(steps[activeStep].stepSubTitle) : $t(steps[activeStep].editStepSubTitle)}}</span>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-row>
                                    <span class="formTitle" style="">{{ $t('locations')}}</span>
                                </b-row>
                                <b-row class="mt-2">
                                    <site-multi-select-tree
                                    :givenSites="allSites"
                                    :givenSelectedSites="getSelectedSiteIds()"
                                    @oninput="selectSite"
                                    style="width:60%;"
                                    class="location-select"
                                    />
                                </b-row>
                            </b-col>
                        </b-row>
                    </template>
                    <template v-else-if="steps[activeStep].stepTitle == 'sourceFactors'">
                        <b-row class="mb-5">
                            <span class="stepSubTitle">{{ modalType == 'insert' ? $t(steps[activeStep].stepSubTitle) : $t(steps[activeStep].editStepSubTitle) }}</span>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-row class="mt-2">
                                    <b-col class="mt-2" style="text-align: left;font-weight: bold;" md="2">{{ $t("current") }}</b-col>
                                    <b-col class="mt-2" style="text-align: left;font-weight: bold;" md="2">{{ $t("target") }}</b-col>
                                    <b-col class="mt-2" style="text-align: left;font-weight: bold;" md="4">{{ $t("value") }}</b-col>
                                    <b-col class="mt-2" style="text-align: left;font-weight: bold;" md="4">{{ $t("example") }}</b-col>
                                </b-row>
                                <b-row v-for="inputFields,key in editedItem.sourceFactors" :key="`factor-convertion-${key}`">
                                    <b-col class="mt-2" md="2">
                                        <b-form-select v-model="inputFields.from" @change="forceUpdate" :key="`from-${key}`" class="white-select" size="m">
                                            <b-form-select-option v-for="unit in inputFields['from_options']" :key="`to-unit-${unit.id}`" :value="unit.id"> {{ unit.label }} </b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col class="mt-2" md="2">
                                        <b-form-select v-model="inputFields.to" @change="forceUpdate" :key="`from-${key}`" class="white-select" size="m">
                                            <b-form-select-option v-for="unit in inputFields['to_options']" :key="`to-unit-${unit.id}`" :value="unit.id"> {{ unit.label }} </b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col class="mt-2" md="4">
                                        <b-form-input type="number" v-model="inputFields.value" @input="forceUpdate"/>
                                    </b-col>
                                    <b-col class="mt-2" md="3">
                                        {{ getExampleConversion(inputFields.from,inputFields.to,inputFields.value) }}
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </template>
                    <template 
                        v-else-if="steps[activeStep].stepTitle == 'emissionFactors'" 
                        v-loading="!isEmissionsLoaded" 
                        :element-loading-text="$t('emissionLibrariesLoading')">
                        <b-row class="mb-5">
                            <span class="stepSubTitle">{{ modalType == 'insert' ? $t(steps[activeStep].stepSubTitle) : $t(steps[activeStep].editStepSubTitle) }}</span>
                        </b-row>
                        <b-row>
                            <b-col>
                                <!-- hidden until emission library addition
                                <b-row align-v="center" style="width:90%">
                                    <b-col md="3">
                                        <span class="formTitle">{{ $t('calculationMethod') }}</span>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-select class="my-1" v-model="scopeGroups[editedItem.scopeGroup].source.calcMethod" :options="[{value: null, text: $t('choose'), disabled: true}, ...['fuel-based', 'test', 'test2']]"></b-form-select>
                                    </b-col>
                                </b-row>
                                -->
                                <b-row class="mt-4 mb-3" align-v="center" style="width:100%">
                                    <b-col md="3">
                                        <span class="formTitle">{{ $t('emissionFactorSource') }}</span>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-select 
                                            class="my-1" 
                                            v-model="editedItem.emissionSource" 
                                            :options="emissionLibraries"
                                            @change="selectEmissionLibrary">
                                        </b-form-select>
                                    </b-col>
                                    <template v-if="modalType == 'insert' && editedItem.emissionSource == null">
                                        <b-col md="1">
                                            <span class="formTitle">{{ $t('source') }}</span>
                                        </b-col>
                                        <b-col md="3">
                                            <b-form-input
                                                class="my-1"
                                                v-model="editedItem.emissionSourceName"
                                                style="height:10%;padding: 5px 10px;"
                                                :placeholder="$t('writeSourceInfo')"/>
                                        </b-col>
                                    </template>
                                    <template v-else-if="editedItem.emissionSource != null">
                                        <b-col md="1">
                                            <span class="formTitle">{{ $t('site') }}</span>
                                        </b-col>
                                        <b-col md="3">
                                            <el-select
                                                style="width:75%"
                                                v-model="editedItem.exampleSiteId"
                                                filterable
                                                @change="setExampleLibrary()"
                                            >
                                                <el-option 
                                                    v-for="site in relatedSites" 
                                                    :key="site.siteId"
                                                    :value="site.siteId"
                                                    :label="site.siteName">
                                                </el-option>
                                            </el-select>
                                        </b-col>
                                    </template>
                                </b-row>
                                <b-row class="my-2" align-v="center" style="width: 75%">
                                    <b-col >
                                        <b-btn 
                                            v-if="modalType == 'update' && editedItem.emissionSource == null"
                                            size="sm" style="float:right;" class="add-custom-factor-btn"
                                            @click="addNewEmissionFactors">
                                                {{$t('addCustomFactor')}}
                                         </b-btn>
                                    </b-col>
                                </b-row>
                                <!-- Insert emission type -->
                                <template v-if="editedItem.emissionSource == null && modalType == 'insert'">
                                    <div v-for="(emissionType,index) in emissionTypes" :key="index">
                                        <!-- if last item -->
                                        <template v-if="index == emissionTypes.length-1">
                                            <b-row class="mt-3" align-v="center" style="width:90%">
                                                <b-col md="3">
                                                </b-col>
                                                <b-col md="4">
                                                    <hr class="my-0 line-text" data-content="or">
                                                </b-col>
                                                <b-col md="4">
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-3" align-v="center" style="width:90%">
                                                <b-col md="3">
                                                </b-col>
                                                <b-col md="1">
                                                    <span class="formTitle">{{ emissionType.name }}</span>
                                                </b-col>
                                                <b-col md="3">
                                                    <masked-input
                                                        v-model="editedItem.emissionFactors[emissionType.name]"
                                                        :keepCharPositions="false"
                                                        type="text"
                                                        :mask="maskOfEmission"
                                                        :placeholder="`${$t('ton')}/${$t(unitMap[editedItem.unit])}`"
                                                        class="masked-input-custom"
                                                        :key="`insert-emission-input-${index}`"
                                                    ></masked-input>
                                                </b-col>
                                                <b-col md="4">
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <template v-else>
                                            <b-row class="mt-3" align-v="center" style="width:90%">
                                                <b-col md="3">
                                                </b-col>
                                                <b-col md="1">
                                                    <span class="formTitle">{{ emissionType.name }}</span>
                                                </b-col>
                                                <b-col md="3">
                                                    <masked-input
                                                        v-model="editedItem.emissionFactors[emissionType.name]"
                                                        :keepCharPositions="false"
                                                        type="text"
                                                        :mask="maskOfEmission"
                                                        :placeholder="`${$t('ton')}/${$t(unitMap[editedItem.unit])}`"
                                                        class="masked-input-custom"
                                                        @input="recalculateCO2e"
                                                        :key="`insert-emission-input-${index}`"
                                                    ></masked-input>
                                                    <!--maskOfEmission(`${$t('ton')}/${$t(unitMap[editedItem.unit])}`)-->
                                                </b-col>
                                                <b-col md="4">
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </div>
                                </template>
                                <template v-else-if="editedItem.emissionSource != null && modalType == 'insert'">
                                    <b-row class="mt-1" align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="1">
                                            <span class="formTitle">CH4</span>
                                        </b-col>
                                        <b-col md="3">
                                            <b-form-input
                                                class="emission-library-factor"
                                                :readonly="true"
                                                :placeholder="emissionLibraryExample.CH4 != null
                                                    ? emissionLibraryExample.CH4 + ` ${$t('ton')}/${$t(unitMap[emissionLibraryExample.unit_id])}`
                                                    : ''"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col md="4">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2" align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="1">
                                            <span class="formTitle">N2O</span>
                                        </b-col>
                                        <b-col md="3">
                                            <b-form-input
                                                class="emission-library-factor"
                                                :readonly="true"
                                                :placeholder="emissionLibraryExample.N2O != null
                                                    ? emissionLibraryExample.N2O + ` ${$t('ton')}/${$t(unitMap[emissionLibraryExample.unit_id])}`
                                                    : ''"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col md="4">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2" align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="1">
                                            <span class="formTitle">CO2</span>
                                        </b-col>
                                        <b-col md="3">
                                            <b-form-input
                                                class="emission-library-factor"
                                                :readonly="true"
                                                :placeholder="emissionLibraryExample.CO2 != null
                                                    ? emissionLibraryExample.CO2 + ` ${$t('ton')}/${$t(unitMap[emissionLibraryExample.unit_id])}`
                                                    : ''"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col md="4">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2" align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="4">
                                            <hr class="my-0 line-text">
                                        </b-col>
                                        <b-col md="4">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-1" align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="1">
                                            <span class="formTitle">CO2e</span>
                                        </b-col>
                                        <b-col md="3">
                                            <b-form-input
                                                class="emission-library-factor"
                                                :readonly="true"
                                                :placeholder="emissionLibraryExample.CO2e != null
                                                    ? emissionLibraryExample.CO2e + ` ${$t('ton')}/${$t(unitMap[emissionLibraryExample.unit_id])}`
                                                    : ''"
                                            ></b-form-input>
                                        </b-col>
                                        <b-col md="4">
                                        </b-col>
                                    </b-row>
                                    <b-row align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="8">
                                            <span style="font-size: .6em;font-weignt:bold;color:#808080" v-if="emissionLocationInfo">
                                                *{{$t('country')}}: {{emissionLocationInfo.countryName}} -
                                                {{$t('region')}}: {{emissionLocationInfo.name}} -
                                                {{$t('sector')}}: {{$t(sectorMap[emissionLibraryExample.sector_id].name)}}
                                            </span>
                                        </b-col>
                                    </b-row>
                                    <b-row align-v="center" style="width:90%">
                                        <b-col md="3">
                                        </b-col>
                                        <b-col md="8">
                                            <span style="font-size: .6em;font-weignt:bold;color:#022b49" v-if="emissionLocationInfo">
                                                {{$t('emissionInfoNotification')}}
                                            </span>
                                        </b-col>
                                    </b-row>
                                </template>
                                <!-- Edit emission type -->
                                <template v-if="this.editedItem.emissionSource == null && modalType == 'update'">
                                    <b-col md="8">
                                    <table class="table table-hover" style="table-layout: fixed;color:#022b49;text-align:left;">
                                        <thead>
                                            <tr>
                                                <th 
                                                    v-for="(field,index) in emissionUpdateTableFields" 
                                                    style="font-size: .9em;border-top: none;text-align:left;"
                                                    :style="`width: ${headerWidths[field.header] || '10em'};`"
                                                    :key="`${activeStep}-${index}`"
                                                    >{{ $t(field.header) }}</th> 
                                                <th id="editColumn" style="width: 4em;border-top: none;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <transition name="fadere" mode="out-in">
                                                <tr v-if="emisssionCustomInsertMode" key="insert-row">
                                                    <td v-for="(field, index) in emissionUpdateTableFields" :key="index" style="font-size: 0.875em;text-align:left;">
                                                        <template v-if="field.key == 'type'">
                                                            <b-form-select v-model="newEmissionModel.editedValue.type" @change="forceUpdate">
                                                                <b-form-select-option v-for="nEmissionType in emissionTypes" :key="nEmissionType.id" :value="nEmissionType.id"> {{ $t(nEmissionType.name) }} </b-form-select-option>
                                                            </b-form-select>
                                                        </template>
                                                        <template v-if="field.key == 'dateRange'">
                                                            <el-date-picker
                                                                :placeholder="$t('chooseDatePlaceholder')"
                                                                v-model="newEmissionModel.editedValue.start"
                                                                type="year"
                                                                format="yyyy"
                                                                style="width: 100%;"
                                                            />
                                                        </template>
                                                        <template v-if="field.key == 'emission'">
                                                            <!-- Update add new emission factor -->
                                                            <masked-input
                                                                v-model="newEmissionModel.editedValue.factor"
                                                                :keepCharPositions="false"
                                                                type="text"
                                                                :mask="maskOfEmission"
                                                                :placeholder="`${$t('ton')}/${$t(unitMap[editedItem.unit])}`"
                                                                class="masked-input-custom"
                                                            ></masked-input>
                                                        </template>
                                                        <template v-if="field.key == 'source'">
                                                            <b-form-input
                                                                v-model="newEmissionModel.editedValue.source"
                                                                :placeholder="$t('source')" />
                                                        </template>
                                                    </td>
                                                    <td :style="{'margin-right': '4px'}">
                                                        <div class="tableBodyCell" style="display:inline;">
                                                            <div key="accept-insert" style="color: #8888; cursor: pointer"
                                                                @click="addNewCustomEmissionFactors(newEmissionModel)">
                                                                <i class="fas fa-check"></i>
                                                            </div>
                                                            <div key="cancel-insert" style="color: #8888; cursor: pointer"
                                                                @click="cancelNewCustomEmissionFactors">
                                                                <i class="fas fa-ban"></i>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </transition>
                                            <tr v-for="(emissionType, index) in editedItem.emissionFactors" :key="index">
                                                <td v-for="(field, indexx) in emissionUpdateTableFields" :key="indexx" style="font-size: 0.875em;text-align:left;">
                                                    <template v-if="field.key == 'type'">
                                                        <template v-if="emissionType.editMode">
                                                            <b-form-select v-model="emissionType.editedValue.type" @change="forceUpdate">
                                                                <b-form-select-option v-for="nEmissionType in emissionTypes" :key="nEmissionType.id" :value="nEmissionType.id"> {{ $t(nEmissionType.name) }} </b-form-select-option>
                                                            </b-form-select>
                                                        </template>
                                                        <template v-else>
                                                            <span>
                                                                {{ getEmissionType(emissionType.value.type) }}
                                                            </span>
                                                        </template>
                                                    </template>
                                                    <template v-if="field.key == 'dateRange'">
                                                        <template v-if="emissionType.editMode">
                                                            <el-date-picker
                                                                :placeholder="$t('chooseDatePlaceholder')"
                                                                v-model="emissionType.editedValue.start"
                                                                type="year"
                                                                format="yyyy"
                                                                style="width: 100%;"
                                                            />
                                                            <el-date-picker
                                                                :placeholder="$t('chooseDatePlaceholder')"
                                                                v-model="emissionType.editedValue.end"
                                                                type="year"
                                                                format="yyyy"
                                                                style="width: 100%;"
                                                            />
                                                        </template>
                                                        <template v-else>
                                                            <span>
                                                                {{ getDateRange(emissionType.editedValue.start, emissionType.editedValue.end) }}
                                                            </span>
                                                        </template>
                                                    </template>
                                                    <template v-if="field.key == 'emission'">
                                                        <template v-if="emissionType.editMode">
                                                            <!-- Update current emission factor -->
                                                            <masked-input
                                                                v-model="emissionType.editedValue.factor"
                                                                :keepCharPositions="false"
                                                                type="text"
                                                                :mask="maskOfEmission"
                                                                :placeholder="`${$t('ton')}/${$t(unitMap[editedItem.unit])}`"
                                                                class="masked-input-custom"
                                                            ></masked-input>
                                                        </template>
                                                        <template v-else>
                                                            <span>
                                                                {{ emissionType.value.factor }} {{`${$t('ton')}/${$t(unitMap[editedItem.unit])}`}}
                                                            </span>
                                                        </template>
                                                    </template>
                                                    <template v-if="field.key == 'source'">
                                                        <template v-if="emissionType.editMode">
                                                            <!-- Update current emission factor -->
                                                            <b-form-input
                                                                v-model="emissionType.editedValue.source"
                                                                :placeholder="$t('source')" />
                                                        </template>
                                                        <template v-else>
                                                            <span>
                                                                {{ emissionType.value.source }}
                                                            </span>
                                                        </template>
                                                    </template>
                                                </td>
                                                <td v-if="emissionType.editMode" :style="{'margin-right': '4px'}">
                                                    <div class="tableBodyCell" style="display:inline-block;">
                                                        <div :key="`accept-${index}`" style="color: #8888; cursor: pointer"
                                                            @click="saveEmissionType(emissionType)">
                                                            <i class="fas fa-check"></i>
                                                        </div>
                                                        <div :key="`cancel-${index}`" style="color: #8888; cursor: pointer"
                                                            @click="revertEmissionType(emissionType)">
                                                            <i class="fas fa-ban"></i>
                                                        </div>
                                                        <div :key="`remove-${index}`" style="color: #8888; cursor: pointer"
                                                            @click="removeEmissionType(emissionType)">
                                                            <i class="fas fa-trash"></i>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td v-else :style="{'margin-right': '4px'}">
                                                    <div class="tableBodyCell">
                                                        <div :key="`editspan-${index}`" style="color: #8888; cursor: pointer"
                                                            @click="emissionType.editMode = true">
                                                            <i class="fas fa-edit fa-lg"></i>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <!--asdasd
                                            <tr v-for="(emissionType, index) in emissionTypes" :key="index">
                                                <td 
                                                    v-for="(field, indexx) in emissionUpdateTableFields" 
                                                    :key="indexx" style="font-size: 0.875em;">
                                                    <template v-if="field.type == 'list'">
                                                        <span> 
                                                            <b-form-select
                                                            v-model="editedItem.emissionFactors[emissionType.id]"
                                                            :options="[{value: null, text: $t('choose')}, ...this.emissionTypes]"
                                                            style="border-radius: unset !important; height: 100%;"
                                                            />
                                                        </span>
                                                    </template>
                                                    <template v-else-if="field.type == 'text' || field.type == 'number'">
                                                        <span>
                                                            <b-form-input
                                                            v-model="editedItem.emissionFactors[emissionType.name]"
                                                            :placeholder="$t(field.header)"
                                                            />
                                                        </span>
                                                    </template>
                                                </td>
                                                <td 
                                                    :style="{width: lastColumnWidth, 'margin-right': '4px'}"
                                                >
                                                    <div class="tableBodyCell">
                                                        <div
                                                            key="editspan"
                                                            style="color: #8888; cursor: pointer"
                                                            >
                                                            <i class="fas fa-edit fa-lg"></i>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            -->
                                        </tbody>
                                    </table>
                                    </b-col>
                                </template>
                                <template v-else-if="this.editedItem.emissionSource != null && modalType == 'update'">
                                    <b-col md="8">
                                        <b-table
                                            hover 
                                            responsive
                                            :items="emissionLibraryData" 
                                            :fields="emissionLibraryDataFields"
                                        ></b-table>
                                        <span style="font-size: .6em;font-weignt:bold;color:#808080" v-if="emissionLocationInfo">
                                            *{{$t('country')}}: {{emissionLocationInfo.countryName}} -
                                            {{$t('region')}}: {{emissionLocationInfo.name}} -
                                            {{$t('sector')}}: {{$t(sectorMap[emissionLibraryExample.sector_id].name)}}
                                        </span>
                                        <br>
                                        <span style="font-size: .6em;font-weignt:bold;color:#022b49" v-if="emissionLocationInfo">
                                            {{$t('emissionInfoNotification')}}
                                        </span>
                                    </b-col>
                                </template>
                            </b-col>
                        </b-row>
                    </template>
                    <template v-else-if="steps[activeStep].stepTitle == 'sourceDesign'">
                        <b-row class="mb-5">
                            <span class="stepSubTitle">{{ modalType == 'insert' ? $t(steps[activeStep].stepSubTitle) : $t(steps[activeStep].editStepSubTitle) }}</span>
                        </b-row>
                        <b-row v-for="(designItem,index) in editedItem.design" :key="index" 
                        :class="['section-line my-2', {'is-design-active': !designItem.active }]">
                            <b-col md="12">
                                <b-row align-h="center">
                                        <span class="formTitle" style="padding-right: 20px;">{{ designItem.key }}</span>
                                        <b-form-checkbox
                                            v-model="designItem.active"
                                            name="checkbox-3"
                                            :value="true"
                                            :unchecked-value="false"
                                            class="checkbox"
                                        >
                                        </b-form-checkbox>
                                    
                                </b-row>
                            </b-col>
                            <template  style="border: 10px solid red;">
                                <b-col md="5">
                                    <b-row style="width: 85%">
                                        <b-col>
                                            <b-row>
                                                <span class="formTitle" style="padding-left: 10px">{{ $t('header') }}</span>
                                            </b-row>
                                            <b-row>
                                                <b-form-input
                                                    class="my-1"
                                                    v-model="designItem.header"
                                                    style="height:10%;padding: 5px 10px;margin-left:10px;"
                                                    :placeholder="$t('header')"/>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col v-if="!['health', 'lastUpdatedAt', 'lastModifier'].includes(designItem.key)" md="3" align-self="center">
                                    <b-row align-h="center">
                                            <b-form-checkbox
                                                v-model="designItem.editable"
                                                name="checkbox-3"
                                                :value="true"
                                                :unchecked-value="false"
                                                class="checkbox"
                                            >
                                            <span class="formTitle" style="padding-right: 20px;">{{ $t('editable') }}</span>
                                            </b-form-checkbox>
                                        
                                    </b-row>
                                </b-col>
                                <b-col v-if="!['health', 'lastUpdatedAt', 'lastModifier'].includes(designItem.key)" md="3" align-self="center">
                                    <b-row align-h="center">
                                            <b-form-checkbox
                                                v-model="designItem.required"
                                                name="checkbox-3"
                                                :value="true"
                                                :unchecked-value="false"
                                                class="checkbox"
                                            >
                                            <span class="formTitle" style="padding-right: 20px;">{{ $t('required') }}</span>
                                            </b-form-checkbox>
                                    </b-row>
                                </b-col>
                            </template>
                        </b-row>
                    </template>
                    <template v-else>
                    </template>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <template v-if="inProgress">
                    <div style="color:#ff0000;">
                        {{ $t('longProcessNotification') }}
                    </div>
                </template>
                <template v-else>
                    <b-button v-if="activeStep != 0" class="modal-button" style="margin-top: 12px;background-color:#E8E8E8;color:#AAABB9" @click="prevStep()">
                        <span key="backArrow">
                            <i class="fas fa-chevron-left"></i>
                            {{$t('back')}}
                        </span>
                    </b-button>
                    <b-button v-if="isLastStep()" class="modal-button" :disabled="checkIfButtonDisabled()" style="margin-top: 12px;background-color:#4129A8;color:#fff;" @click="nextStep()">
                        <span  key="nextArrow">
                            {{$t('next')}}
                            <i class="fas fa-chevron-right"></i>
                        </span>
                    </b-button>
                    <b-button v-else class="modal-button" style="margin-top: 12px;background-color:#4129A8;color:#fff;" :disabled="checkIfButtonDisabled()" @click="saveSource()">
                        <span>
                            {{$t('save')}}
                        </span>
                    </b-button>
                </template>
            </div>
        </b-modal>

        <!-- Confirm Modal -->
        <b-modal ref="confirmSourceDelete" size="md" hide-footer hide-header centered>
            <div class="d-block text-center" style="color:#022b49">
                <b-row align-h="center" class="mb-3">
                    <b-col style="font-weight: bold;font-size: 1.5em;">
                        {{$t('deleteConfirmTitle')}}
                    </b-col>
                </b-row>
                <b-row align-h="center" class="mb-5" >
                    <b-col>
                        {{$t('deleteConfirmText')}}
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col>
                        <b-button size="md" @click="deleteSource(editedItem.id, editedItem.isActive)" variant="danger"  :disabled="inProgress">{{$t('delete')}}</b-button>
                        <b-button size="md" @click="closeDeleteModal()" variant="outline-dark"  :disabled="inProgress">{{$t('cancel')}}</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        
        <!-- Duplicate Source Modal -->
        <b-modal 
            v-model="duplicateSourceModal" 
            :title="$t('duplicateSourceModalTitle')"
            size="md" 
            hide-footer 
            centered
            modal-class="confirm-dialog"
            header-class="border-bottom-0"
            title-class="text-center flex-fill"
        >
            <div class="d-block text-center">
                <b-row align-h="center" class="mb-5">
                    <b-col>
                        {{ $t('duplicateSourceModalText') }}
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col>
                        <b-button size="md" @click="duplicateSource()" variant="primary" >{{ $t('duplicateSourceBtn') }}</b-button>
                        <b-button size="md" @click="convertExistingSource()" variant="primary" >{{ $t('convertExistingSourceBtn') }}</b-button>
                        <b-button size="md" @click="duplicateSourceModal = false" variant="secondary">{{ $t('cancel') }}</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        
        <!-- changeDuplicatedSourceActivation -->
        <b-modal 
            v-model="inactivateSourceModal" 
            :title="$t('inactivateSourceModalTitle')"
            size="md" 
            hide-footer 
            centered
            modal-class="confirm-dialog"
            header-class="border-bottom-0"
            title-class="text-center flex-fill"
        >
            <div class="d-block text-center">
                <b-row align-h="center" class="mb-5">
                    <b-col>
                        {{ $t('inactivateSourceModalText') }}
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col>
                        <b-button size="md" @click="changeDuplicatedSourceActivation(true)" variant="primary" >{{ $t('yes') }}</b-button>
                        <b-button size="md" @click="changeDuplicatedSourceActivation(false)" variant="primary" >{{ $t('no') }}</b-button>
                        <b-button size="md" @click="inactivateSourceModal = false" variant="secondary">{{ $t('cancel') }}</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        
        <!-- convert-exist -->
        <b-modal 
            v-model="convertUnitsModal" 
            :title="$t('convertUnitsModalTitle')"
            size="md" 
            hide-footer 
            centered
            modal-class="confirm-dialog"
            header-class="border-bottom-0"
            title-class="text-center flex-fill"
        >
            <div class="d-block text-center">
                <b-row align-h="center" class="mb-5">
                    <b-col>
                        {{ $t('convertUnitsModalText') }}
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col v-if="pageSource === 'sourceSummary'">
                        <b-button size="md" @click="changeExistingSource(true)" variant="primary" >{{ $t('yes') }}</b-button>
                        <!-- <b-button v-if="this.editedItem.unit === this.editedItemRaw.unit" size="md" @click="changeExistingSource(false)" variant="primary" >{{ $t('no') }}</b-button> -->
                        <b-button size="md" @click="convertUnitsModal = false" variant="secondary">{{ $t('cancel') }}</b-button>
                    </b-col>
                    <b-col v-else-if="pageSource === 'sourceManagement'">
                        <b-button size="md" @click="updateSourceManagement(true)" variant="primary" >{{ $t('yes') }}</b-button>
                        <b-button size="md" @click="updateSourceManagement(false)" variant="primary" >{{ $t('no') }}</b-button>
                        <b-button size="md" @click="convertUnitsModal = false" variant="secondary">{{ $t('cancel') }}</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import SiteMultiSelectTree from '@/components/SiteMultiSelectTree.vue';
import _ from 'lodash';
import moment from 'moment';
import Bignumber from "bignumber.js"

export default {
    name: 'CreateSource',
    components: {
        SiteMultiSelectTree,
    },
    data() {
        return {
            pageSource: '',
            duplicateSourceModal: false,
            convertUnitsModal: false,
            inactivateSourceModal: false,
            sourceTabs: null,
            activeStep: 0,
            showModal: false,
            modalType: null,
            allSites: [],
            scopeGroups: null,
            selectedItem: {},
            steps: [],
            rawSteps: [ 
                {
                    stepTitle: 'selectActivity',
                    editStepTitle: 'activity',
                    stepSubTitle: 'selectActivityTitle',
                    editStepSubTitle: 'selectActivityTitle'
                },
                {
                    stepTitle: 'defineSources',
                    editStepTitle: 'source',
                    stepSubTitle: 'defineSourcesTitle',
                    editStepSubTitle: 'source'
                },
                {
                    stepTitle: 'assignLocations',
                    editStepTitle: 'locations',
                    stepSubTitle: 'assignLocations',
                    editStepSubTitle: 'locations'
                },
                {
                    stepTitle: 'emissionFactors',
                    editStepTitle: 'emissionFactors',
                    stepSubTitle: 'emissionFactorsTitle',
                    editStepSubTitle: 'emissionFactorsTitle'
                },
                /*
                {
                    stepTitle: 'sourceFactors',
                    editStepTitle: 'sourceFactors',
                    stepSubTitle: 'sourceFactorsTitle',
                    editStepSubTitle: 'sourceFactorsTitle'
                }
                */
            ],
            editedItem: {
                emissionFactors: {},
                locations: [],
            },
            editedItemRaw: {},
            normalizationTypes:["-", "area", "person"],
            unitList: [],
            unitMap: {},
            unitTypeMap:{id:{},name:{}},
            newEmissionModel: {},
            emissionUpdateTableFields:[
                {"key":"type","header":"greenhouseGas","type":"list"},
                {"key":"dateRange","header":"start","type":"list"},
                {"key":"emission","header":"emissionFactor","type":"text"},
                {"key":"source","header":"source","type":"text"}
            ],
            headerWidths: {
                emissionFactor: '12em',
                start: '11em',
            },
            emisssionCustomInsertMode: false,
            emissionTypes: null,
            inProgress: false,
            errors: {
                1: {
                    sourceName: false,
                    sourceType: false,
                    sourceTypeGroup: false,
                    unit: false,
                    validFrom: false,
                },
                2: {
                    locations: false,
                },
                3: {
                    emissionFactor: false
                }
            },
            rawDesign: [
                {
                    key: "value1",
                    active: true,
                    header: "Miktar",
                    "type": "float",
                    editable: true,
                    required: true
                },
                {
                    key: "cost",
                    active: true,
                    header: "Maliyet",
                    "type": "float",
                    editable: true,
                    required: true
                },
                {
                    key: "paymentMethod",
                    active: true,
                    header: "Ödeme Yöntemi",
                    "type": "select",
                    editable: true,
                    required: false
                },
                {
                    key: "date",
                    active: true,
                    header: "Tarih Aralığı",
                    "type": "daterange",
                    editable: true,
                    required: true
                },
                {
                    key: "health",
                    active: true,
                    header: "Veri Sağlığı",
                    "type": "icon",
                    editable: false,
                    required: false
                },
                {
                    key: "file",
                    active: true,
                    header: "Fatura",
                    "type": "file",
                    editable: true,
                    required: false
                },
                {
                    key: "description",
                    active: true,
                    header: "description",
                    "type": "text",
                    editable: true,
                    required: false
                },
                {
                    key: "lastUpdatedAt",
                    active: true,
                    header: "Son Değişiklik Tarihi",
                    "type": "date",
                    editable: false,
                    required: false
                },
                {
                    key: "lastModifier",
                    active: true,
                    header: "Son Düzenleyen",
                    "type": "identity",
                    editable: false,
                    required: false
                },
            ],
            rawDesignIsb: [
                {
                    key: "value1",
                    active: true,
                    header: "Miktar",
                    "type": "float",
                    editable: true,
                    required: true
                },
                {
                    key: "cost",
                    active: true,
                    header: "Maliyet",
                    "type": "float",
                    editable: true,
                    required: true
                },
                {
                    key: "paymentMethod",
                    active: false,
                    header: "Ödeme Yöntemi",
                    "type": "select",
                    editable: true,
                    required: false
                },
                {
                    key: "date",
                    active: true,
                    header: "Tarih Aralığı",
                    "type": "daterange",
                    editable: true,
                    required: true
                },
                {
                    key: "health",
                    active: true,
                    header: "Veri Sağlığı",
                    "type": "icon",
                    editable: false,
                    required: false
                },
                {
                    key: "file",
                    active: true,
                    header: "Fatura",
                    "type": "file",
                    editable: true,
                    required: true
                },
                {
                    key: "description",
                    active: true,
                    header: "description",
                    "type": "text",
                    editable: true,
                    required: false
                },
                {
                    key: "lastUpdatedAt",
                    active: true,
                    header: "Son Değişiklik Tarihi",
                    "type": "date",
                    editable: false,
                    required: false
                },
                {
                    key: "lastModifier",
                    active: true,
                    header: "Son Düzenleyen",
                    "type": "identity",
                    editable: false,
                    required: false
                },
            ],
            isLoaded: false,
            isEmissionsLoaded: false,
            emissionLibraries: [],
            relatedSites: [],
            emissionLibraryExample: {},
            emissionLibraryContents: {},
            emissionLocationInfo: null,
            emissionLibraryDataFields: [
                {
                    label: this.$t('greenhouseGas'),
                    key: 'name',
                    thClass: 'emission-th',
                    tdClass: 'emission-td',
                    stickyColumn: true
                },
                {
                    label: this.$t('start'),
                    key: 'start',
                    thClass: 'emission-th',
                    tdClass: 'emission-td',
                    stickyColumn: true
                },
                {
                    label: this.$t('emissionFactor'),
                    key: 'emissionFactor',
                    thClass: 'emission-th',
                    tdClass: 'emission-td',
                    stickyColumn: true
                }
            ],
            emissionLibraryData: [],
        }
    },
    methods: {
        forceUpdate() {
            this.$forceUpdate();
        },
        onShowModal() {
            this.init().then(() => {
                if(this.route.params.site_id) {
                    this.steps = _.filter(this.rawSteps, step => _.get(step, 'stepTitle') !== 'assignLocations');
                }

                this.activeStep = 0;
                this.showModal = true;
                this.allSites = this.sitesWithGroups;

                this.eventId = this.$store.state.modal.eventId;
                this.type = this.$store.state.modal.type;
                this.pageSource = this.$store.state.modal.payload.page;

                if(this.type === 'createSource') {
                    this.modalType = 'insert';
                    this.prepareCreateModalData();
                } else {
                    this.modalType = 'update';
                    this.selectedItem = this.$store.state.modal.payload.selectedItem;
                    this.prepareUpdateModalData(this.selectedItem);
                }
            });
        },
        onHideModal(){
            this.activeStep = 0;
            this.editedItem = {};
            this.showModal = false;
            this.modalType = null;
            _.each(this.scopeGroups, o => {o.isSelected = false});

            this.scopeGroups = null;

            // Revert steps to its original state
            this.steps = _.clone(this.rawSteps);
        },
        prepareCreateModalData() {
            this.activeStep = 0;
            this.modalType = 'insert';
            this.editedItem = {
                name: null,
                scopeGroup: null,
                sourceTypeGroup: null,
                sourceType: null,
                unit: null,
                normalizationType: '-',
                validFrom: null,
                until: null,
                isActive: true,
                hazardous: null,
                locations: [],
                emissionSource: null,
                emissionSourceName: '',
                emissionFactors: {},
                sourceFactors: {},
                design: _.cloneDeep(this.isbId(this.$store.state.user.customerId) ? this.rawDesignIsb :this.rawDesign),
                exampleSiteId: null,
            };
            if(this.route.params.site_id) {
                this.editedItem.locations.push(this.route.params.site_id);
            }
        },
        prepareUpdateModalData(selectedItem) {

            let scopeGroupKey = _.indexOf(this.scopeGroups, _.find(this.scopeGroups, o=> o.id==_.get(selectedItem, 'scopeGroup')));
            
            if(_.includes(['water', 'water usage'], _.lowerCase(this.scopeGroups[scopeGroupKey].name))){
                this.steps = _.filter(_.clone(this.steps), o => o.stepTitle != 'emissionFactors');
            } 
            
            this.activeStep = 0;
            this.modalType = 'update';
            let emissions = _.map(_.get(selectedItem, 'emissions'), emission=>{
                return {
                    id: emission.id,
                    editMode: false,
                    value:{
                        type: emission.type,
                        start: emission.startDate,
                        end: emission.endDate,
                        factor: this.localizeValue(new Bignumber(emission.factor).toFixed(), this.locale),
                        source: emission.source,
                        unit: `ton/${this.unitMap[_.get(selectedItem, 'unit')]}`
                    },
                    editedValue:{
                        type: emission.type,
                        start: emission.startDate,
                        end: emission.endDate,
                        factor: this.localizeValue(new Bignumber(emission.factor).toFixed(), this.locale),
                        source: emission.source,
                        unit: `ton/${this.unitMap[_.get(selectedItem, 'unit')]}`
                    }
                }
            });
            emissions = _.sortBy(emissions,o=> moment(o.value.start).year(), 'desc');
            let sourceFactors = {};
            _.each(_.get(selectedItem, 'sourceFactors'), sourceFactor=>{
                let toType = this.unitTypeMap.id[sourceFactor.to];
                let fromType = this.unitTypeMap.id[sourceFactor.from]
                sourceFactors[toType] = {
                    ...sourceFactor,
                    from_options: _.filter(this.unitList, o=> (fromType == this.unitTypeMap.id[o.id])),
                    to_options: _.filter(this.unitList, o=> (toType == this.unitTypeMap.id[o.id]))
                };
            })

            let innerDesign = _.cloneDeep(_.get(selectedItem, 'design'));
            let controlDesign = _.cloneDeep(this.isbId(this.$store.state.user.customerId) ? this.rawDesignIsb :this.rawDesign);
            let design = _.map(controlDesign, design=>{
                    let nDesign = _.find(innerDesign, o=>o.key==design.key)
                    if(nDesign){
                        return {...nDesign, active: true};
                    }
                    else{
                        design['active'] = false
                        return design;
                    }
                });
            this.editedItem = {
                id: _.get(selectedItem, 'id'),
                name: _.get(_.get(_.get(selectedItem, 'cols'), 'name'), 'value') || _.get(_.get(_.get(selectedItem, 'cols'), 'dataType'), 'value'),
                scopeGroup: scopeGroupKey,
                sourceTypeGroup: _.get(selectedItem, 'sourceTypeGroup'),
                sourceType: _.get(selectedItem, 'sourceType'),
                unit: _.get(selectedItem, 'unit'),
                normalizationType: _.get(selectedItem, 'normalizationType'),
                validFrom: null,
                until: null,
                isActive: _.get(selectedItem, 'isActive'),
                hazardous: _.get(selectedItem, 'hazardous') == undefined ? false : true,
                locations: _.get(selectedItem, 'locations'),
                emissionSource: _.get(selectedItem, 'emissionSource'),
                emissionSourceName: _.get(selectedItem, 'emissionSourceName'),
                emissionFactors: emissions,
                sourceFactors: sourceFactors,
                design: design,
                exampleSiteId: null
            };
            this.scopeGroups[this.editedItem.scopeGroup].isSelected = true;
            /*
            _.each(this.scopeGroups, o=> {
                if(o.id == _.get(item, 'scopeGroup')){
                    o.isSelected = true;
                }
            });
            */

           this.editedItemRaw = _.cloneDeep(this.editedItem);

            // this.$refs.itemEditModal.show();
        },
        selectScopeGroup(scopeGroup, key){
            if(this.modalType == 'insert'){
                let selectedScopeGroup = _.find(this.scopeGroups, o => { return o.isSelected == true });
                if(selectedScopeGroup) {
                    if(scopeGroup.isSelected) {
                        scopeGroup.isSelected = false;
                        this.editedItem.scopeGroup = null;
                    } else {
                        selectedScopeGroup.isSelected = false;
                        scopeGroup.isSelected = true;
                        this.editedItem.scopeGroup = key;
                    }
                } else {
                    scopeGroup.isSelected = true;
                    this.editedItem.scopeGroup = key;
                }
                this.resetFieldValues(1);

                // If scope group is water related, disable emission factor step
                if(_.includes(['water', 'water usage'], _.lowerCase(this.scopeGroups[key].name))){
                    this.steps = _.filter(_.clone(this.steps), o => o.stepTitle != 'emissionFactors')
                } 
                // If scope group is not water related revert steps back to its original steps according to location filter
                else {
                    if(this.route.params.site_id) {
                        this.steps = _.filter(this.rawSteps, step => _.get(step, 'stepTitle') !== 'assignLocations');
                    } else {
                        this.steps = _.clone(this.rawSteps);
                    }
                }
            }
        },
        resetFieldValues(step){
            if(step == 1){
                this.editedItem.name = null;
                this.editedItem.sourceTypeGroup = null;
                this.editedItem.sourceType = null;
                this.editedItem.unit = null;
                this.editedItem.validFrom = null;
                this.editedItem.until = null;
                this.editedItem.hazardous = false;
            } else if(step == 2) {
                this.editedItem.locations = [];
            } else if(step == 3) {
                this.editedItem.emissionSource =  null;
                this.editedItem.emissionFactors = {};
            }
        },
        isSourceTypeGroupAvailable(){
            let sourceTypeGroups = this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups;
            if(sourceTypeGroups.length == 1){
                this.editedItem.sourceTypeGroup = sourceTypeGroups[0].id;
            }
            return sourceTypeGroups.length > 1;
        },
        getSelectedSiteIds(){
            return this.createGroupedSitesKeys(this.editedItem.locations);
        },
        selectSite(value){
            _.set(this.editedItem, 'locations', this.getSiteIdsInGroupedSitesMap(value))
        },
        arrangeOptions(selectData, sourceTypeSelect=false){
            let options =  _.map(selectData, selectItem => {
                if(sourceTypeSelect){
                    selectItem = {value:selectItem, text:this.$t(this.sourceTypes[selectItem].name), disabled: false};
                } else {
                    selectItem = {value:selectItem.id, text:this.$t(selectItem.label), disabled: false};
                }
                return selectItem;
            })
            return [{value: null, text: this.$t('choose'), disabled: true}, ...options];
        },
        getExampleConversion(from,to,value){
            if(from && to && value != null){
                let val = 1*_.toNumber(value);
                return `1 ${this.unitMap[from]} = ${val} ${this.unitMap[to]}`;
            }
        },
        addNewEmissionFactors(){
            if(_.isNull(this.editedItem.emissionSource)){
                this.newEmissionModel = {
                    id: null,
                    editMode: false,
                    value:{
                        type: null,
                        start: null,
                        end: null,
                        factor: null,
                        source: null,
                        unit: `ton/${this.unitMap[_.get(this.editedItem, 'unit')]}`
                    },
                    editedValue:{
                        type: null,
                        start: null,
                        end: null,
                        factor: null,
                        source: null,
                        unit: `ton/${this.unitMap[_.get(this.editedItem, 'unit')]}`
                    }
                }
                this.emisssionCustomInsertMode = true;
            }
            this.forceUpdate();
        },
        cancelNewCustomEmissionFactors(){
            this.emisssionCustomInsertMode = false;
        },
        addNewCustomEmissionFactors(factors){
            factors.value = {
                type: factors.editedValue.type,
                start: moment(factors.editedValue.start).startOf('year'),
                end: moment(factors.editedValue.start).add(10, 'year').endOf('year'),
                factor: factors.editedValue.factor,
                source: factors.editedValue.source,
                unit: factors.editedValue.unit
            };
            factors.editedValue=factors.value;
            this.editedItem.emissionFactors.push(factors);
            this.emisssionCustomInsertMode = false;
            this.formatDatesOfEmissions(factors.value.type);
            this.recalculateCO2eForGivenYears(factors.value.start, factors.value.end);
            this.editedItem.emissionFactors = _.sortBy(this.editedItem.emissionFactors,o=> moment(o.value.start).year(), 'asc')
            this.forceUpdate();
        },
        formatDatesOfEmissions(emissionTypeId){
            //let selectedEmissionGroup = _.filter(this.editedItem.emissionFactors, o=> o.value.type == emissionTypeId);
            let selectedEmissionGroup = _.flow(
                _.partialRight(_.filter, o=> o.value.type == emissionTypeId),
                _.partialRight(_.sortBy, o=> moment(o.value.start).year())
            )(this.editedItem.emissionFactors);
            _.each(selectedEmissionGroup, (emission,index)=>{
                if(index < _.size(selectedEmissionGroup)-1){
                    emission.editedValue.end = moment(selectedEmissionGroup[index+1].editedValue.start).subtract(1, 'year').endOf('year');
                    emission.value = emission.editedValue;
                }
            })
        },
        recalculateCO2eForGivenYears(startDate, endDate){
            let N2OId = this.getEmissionId('N2O'), CH4Id = this.getEmissionId('CH4'), CO2Id = this.getEmissionId('CO2'), CO2eId = this.getEmissionId('CO2e');
            let relatedEmissionValues = _.filter(this.editedItem.emissionFactors, o=> (moment(o.value.start).isSame(startDate, 'year') && moment(o.value.end).isSame(endDate, 'year')))
            if(_.size(_.intersection(_.map(_.map(relatedEmissionValues, 'value'), 'type'), [N2OId, CH4Id, CO2Id])) == 3){
                let n2o = _.find(relatedEmissionValues, o=> o.value.type == N2OId);
                let ch4 = _.find(relatedEmissionValues, o=> o.value.type == CH4Id);
                let co2 = _.find(relatedEmissionValues, o=> o.value.type == CO2Id);
                let co2e = _.find(relatedEmissionValues, o=> o.value.type == CO2eId);
                let newCO2eFactor = this.localizeValue(new Bignumber(this.delocalizeValueForBN(co2.value.factor, this.locale))
                        .plus(new Bignumber(this.delocalizeValueForBN(ch4.value.factor, this.locale)).multipliedBy(28))
                        .plus(new Bignumber(this.delocalizeValueForBN(n2o.value.factor, this.locale)).multipliedBy(265))
                        .toFixed(), this.locale);
                if(co2e){
                    co2e.editedValue.factor = newCO2eFactor
                    co2e.value = co2e.editedValue;
                }
                else{
                    let factor = {
                        id: null,
                        editMode: false,
                        value:{
                            type: CO2eId,
                            start: n2o.value.start,
                            end: n2o.value.end,
                            factor: newCO2eFactor,
                            source: n2o.value.source,
                            unit: n2o.value.unit
                        },
                        editedValue:{
                            type: CO2eId,
                            start: n2o.value.start,
                            end: n2o.value.end,
                            factor: newCO2eFactor,
                            source: n2o.value.source,
                            unit: n2o.value.unit
                        }
                    }
                    this.editedItem.emissionFactors.push(factor);
                }
                this.formatDatesOfEmissions(CO2eId);
            }
        },
        recalculateCO2e(){
            let filteredDataKeys = _.flow(
                _.partialRight(_.map, (value,key)=> {
                        return {
                            key: key,
                            value: value
                        }
                    }),
                _.partialRight(_.filter, o=> (o.value != '' && o.value != 'NaN' && !_.isNaN(o.value))),
                _.partialRight(_.map, 'key')
            )(this.editedItem.emissionFactors);
            if(_.size(_.intersection(filteredDataKeys, ['N2O', 'CH4', 'CO2'])) == 3){
                let co2eVal = this.localizeValue(new Bignumber(this.delocalizeValueForBN(this.editedItem.emissionFactors['CO2'], this.locale))
                    .plus(new Bignumber(this.delocalizeValueForBN(this.editedItem.emissionFactors['CH4'], this.locale)).multipliedBy(28))
                    .plus(new Bignumber(this.delocalizeValueForBN(this.editedItem.emissionFactors['N2O'], this.locale)).multipliedBy(265))
                    .toFixed(), this.locale);

                if(this.editedItem.emissionFactors['CO2e'] != undefined){
                    if(this.editedItem.emissionFactors['CO2e'] != co2eVal){
                        this.editedItem.emissionFactors['CO2e'] = co2eVal;
                    }
                }
                else{
                    this.editedItem.emissionFactors['CO2e'] = co2eVal;
                }
                
                //(CO2.factor*1+CH4.factor*28+N2O.factor*265)
            }

            this.forceUpdate();
        },
        saveEmissionType(emissionType){
            emissionType.value = _.clone(emissionType.editedValue);
            emissionType.editMode = false;
            this.formatDatesOfEmissions(emissionType.value.type);
            if(emissionType.value.type != this.getEmissionId('CO2e')){
                this.recalculateCO2eForGivenYears(emissionType.value.start, emissionType.value.end);
            }
            this.editedItem.emissionFactors = _.sortBy(this.editedItem.emissionFactors,o=> moment(o.value.start).year(), 'asc')
            this.forceUpdate();
        },
        revertEmissionType(emissionType){
            emissionType.editedValue = _.clone(emissionType.value);
            emissionType.editMode = false;
        },
        removeEmissionType(emissionType){
            _.remove(this.editedItem.emissionFactors, emissionType)
            this.forceUpdate();
        },
        getEmissionId(name){
            return _.find(this.emissionTypes, o=>o.name == name).id;
        },
        getEmissionType(id){
            return _.find(this.emissionTypes, o=>o.id == id).name;
        },
        
        saveSource(){
            if (this.modalType == 'update') {
                this.updateSource();
            } else {
                this.insertSource();
            }
        },
        // Updates source by given cirscumtances
        updateSource() {
            // If page is source management
            if(this.pageSource === 'sourceManagement') {
                
                if(this.editedItem.unit === this.editedItemRaw.unit) {
                    this.updateSourceManagement(false);
                } else {
                    this.convertUnitsModal = true;
                }
            // If page is data summary
            } else if(this.pageSource === 'sourceSummary') {

                const action = this.getUpdatedType();

                switch (action) {
                    // If source type definitions or emission factors are changed, calls duplicateSourceModal
                    case 'duplicate':
                        this.duplicateSourceModal = true;
                        break;

                    // If only active/passive state is changed, update site's activation state
                    case 'activationUpdate':
                        this.inProgress = true;
                        this.$Progress.start();
                        
                        this.axios.put('/siteSourceActivationUpdate', {
                            sourceId: this.editedItem.id,
                            isActive: this.editedItem.isActive,
                            siteId: this.route.params.site_id,
                            year: this.$store.state.year
                        })
                        .then(() => {
                            this.$Progress.finish();
                            this.$refs.createSource.hide();
                            this.inProgress = false;
                            this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
                        });
                        break;
                
                    default:
                        this.$refs.createSource.hide();
                        break;
                }
            }
        },
        // Determines required action for updating source
        getUpdatedType() {
            // If emission data type definitions or emission factors are changed
            if (
                this.editedItemRaw.name !== this.editedItem.name
                || this.editedItemRaw.sourceTypeGroup !== this.editedItem.sourceTypeGroup
                || this.editedItemRaw.sourceType !== this.editedItem.sourceType
                || this.editedItemRaw.unit !== this.editedItem.unit
                || this.editedItemRaw.normalizationType !== this.editedItem.normalizationType
                || this.editedItemRaw.hazardous !== this.editedItem.hazardous
                || !_.isEqual(this.editedItemRaw.emissionFactors, this.editedItem.emissionFactors)
                || !_.isEqual(this.editedItemRaw.sourceFactors, this.editedItem.sourceFactors)
                || !_.isEqual(this.editedItemRaw.design, this.editedItem.design)
            ) {
                return 'duplicate';
            // If only active/passive state is changed
            } else if (this.editedItemRaw.isActive !== this.editedItem.isActive) {
                return 'activationUpdate';
            } else {
               return 'none';
            }
        },
        // If source is active opens inactivateSourceModal, else creates new duplication
        duplicateSource() {
            if(this.editedItemRaw.isActive) {
                this.inactivateSourceModal = true;
            } else {
                this.changeDuplicatedSourceActivation(false);
            }
        },
        // If source definitions are changes but unit is not changed, changes source by creating new duplication
        // else opens convertUnitsModal modal
        convertExistingSource() {
            if(this.editedItem.unit === this.editedItemRaw.unit) {
                this.changeExistingSource(false);
            } else {
                this.convertUnitsModal = true;
            }
        },
        // Updates sources for all locations
        updateSourceManagement(changeUnits) {
            let newItem = this.generateNewItem(true);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();

            this.axios.put('/sources', {
                item: newItem,
                editingLocationActivations: this.editedItemRaw.isActive,
                changeUnits,
                oldUnitId: this.editedItemRaw.unit
            })
            .then(() => {
                this.$store.dispatch("getDataTypes");
                this.$store.dispatch("getSites");
                this.$Progress.finish();
                this.$refs.createSource.hide();
                this.inProgress = false;
                this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
            });
        },
        // Changes source by creating new duplication
        changeExistingSource(convertUnits) {
            let newItem = this.generateNewItem(true);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();

            this.axios.post('/changeExistingSource', {
                item: newItem,
                convertUnits,
                year: this.$store.state.year,
                siteId: _.toNumber(this.route.params.site_id),
                oldUnit: this.editedItemRaw.unit
            })
            .then(() => {
                this.$store.dispatch("getDataTypes");
                this.$store.dispatch("getSites");
                this.$Progress.finish();
                this.$refs.createSource.hide();
                this.inProgress = false;
                this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
            })
            .catch(err => {
                if(err.response.data.code === "InvalidContent") {
                    this.$Progress.finish();
                    this.inProgress = false;

                    this.$confirm(this.$t('invalidUnits'), this.$t('warning'), {
                        cancelButtonText: this.$t('back'),
                        type: 'warning',
                        center: true,
                        showConfirmButton: false
                    });
                 
                    // this.$confirm(this.$t('invalidUnits'), this.$t('warning'), {
                    //     confirmButtonText: this.$t('saveWithoutConvert'),
                    //     cancelButtonText: this.$t('cancel'),
                    //     type: 'warning',
                    //     center: true
                    // })
                    //     .then(() => this.changeExistingSource(false))
                    //     .catch(() => {});
                }
            });
        },
                
        // Creates new source group by duplication and changes its active/passive state
        changeDuplicatedSourceActivation(inactiveExistDataType) {
            let newItem = this.generateNewItem(true);
            // _.set(newItem, 'locations', [_.toNumber(this.route.params.site_id)]);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();
            
            this.axios.post('/duplicateSourceGroup', {
                item: newItem,
                inactivate: inactiveExistDataType,
                year: this.$store.state.year
            })
            .then(() => {
                this.$store.dispatch("getDataTypes");
                this.$store.dispatch("getSites");
                this.$Progress.finish();
                this.$refs.createSource.hide();
                this.inProgress = false;
                this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
            });
        },
        // changeExistSourceByDuplication(convertUnits) {
        //     let newItem = this.generateNewItem(true);
        //     this.inProgress = true;
        //     this.$Progress.start();

        //     this.axios.post('/changeExistSourceByDuplication', {
        //         item: newItem,
        //         convertUnits
        //     })
        //     .then(() => {
        //         this.$Progress.finish();
        //         this.$refs.createSource.hide();
        //         this.inProgress = false;
        //         this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
        //     });
        // },

        insertSource(){
            this.inProgress=true;
            this.$Progress.start();
            let newItem = this.generateNewItem(false);
       
            return this.axios.post('/sources', newItem)
                .then(()=>{
                    this.$store.dispatch("getDataTypes");
                    this.$store.dispatch("getSites");
                    this.$Progress.finish();
                    this.$refs.createSource.hide();
                    this.inProgress=false;
                    this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'insert'});
                });
        },
        deleteSource(id, isActive) {
            this.inProgress=true;
            this.$Progress.start();
            this.closeDeleteModal();
            return this.axios.delete(`/sources/${id}/${this.route.params.site_id}`)
                .then(()=>{
                    this.$Progress.finish();
                    this.$refs.createSource.hide();
                    this.inProgress=false;
                    this.forceUpdate();
                    this.$eventHub.$emit(this.$store.state.modal.eventId, { 
                        emitter: 'delete',
                        data: { 
                            id, 
                            isActive
                        }
                    });
                });
        },
        generateNewItem(getId){
            let selectedScopeGroup = this.scopeGroups[this.editedItem.scopeGroup];
            let tags= [selectedScopeGroup.id, this.editedItem.sourceTypeGroup, this.editedItem.sourceType];
            _.each(selectedScopeGroup.parentData, o=>{
                if(this.editedItem.hazardous){
                    tags.push(o.rel_id)
                }
                else{
                    if(o.type != 'hazardous'){
                        tags.push(o.rel_id)
                    }
                }
            });
            let design = {
                table:_.map(_.filter(this.editedItem.design, o=>o.active), k=>_.omit(k,'active')),
                info:{tableName:this.editedItem.name}
            }
            let emissions = _.map(this.editedItem.emissionFactors, (value,key)=>{
                if (getId) {
                    return {
                        id: _.get(value, 'id'),
                        emission_id: _.get(value.value, 'type'),
                        value: this.removeZeros(this.delocalizeValue(_.get(value.value, 'factor'), this.locale)),
                        source: _.get(value.value, 'source'),
                        unit: _.get(value.value, 'unit'),
                        start_date: _.get(value.value, 'start'),
                        end_date: _.get(value.value, 'end')
                    }
                } else {
                    return {
                        emission_id: _.get(_.first(_.filter(this.emissionTypes, o=> o.name == key)), 'id'),
                        value: this.removeZeros(this.delocalizeValue(value, this.locale)),
                        source: this.editedItem.emissionSourceName,
                        unit: `ton/${this.unitMap[this.editedItem.unit]}`,
                        start_date: moment().startOf('year'),
                        end_date: moment().add(10, 'year').endOf('year')
                    }
                }
            });
            emissions = _.filter(emissions, emission => _.get(emission, 'value') != '');
            let emissionLibrarySource = _.find(this.emissionLibraries, o=> o.value == this.editedItem.emissionSource);
            return {
                id: getId ? this.editedItem.id : null,
                isActive: this.editedItem.isActive,
                name: this.editedItem.name,
                locations: this.editedItem.locations == null ? [] : this.editedItem.locations,
                unit: this.editedItem.unit,
                normalizationType: this.editedItem.normalizationType,
                tags: tags,
                user_source_factors: _.map(_.filter(this.editedItem.sourceFactors, k => !(_.isNull(k.from) && _.isNull(k.to) && _.isNull(k.value))), o=>{return {from:o.from, to:o.to, value:o.value}}),
                emission_factors: emissions,
                emissionSource: this.editedItem.emissionSource,
                emissionSourceName: emissionLibrarySource != undefined ? 'self_'+emissionLibrarySource.text : null,
                design: design,
                has_emission: !_.isEmpty(emissions)

            }
        },
        updateSourceFactorOptions(){
            let selectedSourceType = this.sourceTypes[this.editedItem.sourceType];
            let possibleTypes = _.uniq(_.map(selectedSourceType.units, o=>{return this.unitTypeMap.id[o.id]}));
            let selectedUnitType = this.unitTypeMap.id[this.editedItem.unit];
            this.editedItem['sourceFactors'] = {};
            if(selectedUnitType != 'other'){
                _.each(possibleTypes, unitType=>{
                    if(!_.includes([selectedUnitType, 'other'], unitType)){
                        let existData = _.get(_.get(selectedSourceType['source_factors'], selectedUnitType), unitType);
                        if(existData == undefined){
                            this.editedItem['sourceFactors'][unitType] = {
                                from:null,
                                to:null,
                                value:null,
                                from_options: _.filter(this.unitList, o=> (selectedUnitType == this.unitTypeMap.id[o.id])),//_.filter(this.sourceTypes[this.editedItem.sourceType].units, o=> (unitType == this.unitTypeMap.id[o.id])),
                                to_options: _.filter(this.unitList, o=> (unitType == this.unitTypeMap.id[o.id]))//_.filter(this.sourceTypes[this.editedItem.sourceType].units, o=> (selectedType == this.unitTypeMap.id[o.id]))
                            }
                        }else{
                            this.editedItem['sourceFactors'][unitType] = {
                                from:existData.from,
                                to:existData.to,
                                value:existData.value,
                                from_options: _.filter(this.unitList, o=> (selectedUnitType == this.unitTypeMap.id[o.id])),
                                to_options: _.filter(this.unitList, o=> (unitType == this.unitTypeMap.id[o.id]))
                            }
                        }
                    }
                });
                if(_.includes(['water', 'water usage'], _.lowerCase(this.scopeGroups[this.editedItem.scopeGroup].name))){
                    this.steps = _.filter(_.clone(this.steps), o => o.stepTitle != 'emissionFactors');
                    // this.steps = _.filter(_.clone(this.rawSteps), o => o.stepTitle != 'emissionFactors');
                }
                // else{
                //     this.steps = _.clone(this.rawSteps);
                // }
            }
            else{
                if(_.includes(['water', 'water usage'], _.lowerCase(this.scopeGroups[this.editedItem.scopeGroup].name))){
                    this.steps = _.filter(_.clone(this.steps), o => !_.includes(['emissionFactors','sourceFactors'], o.stepTitle));
                    // this.steps = _.filter(_.clone(this.rawSteps), o => !_.includes(['emissionFactors','sourceFactors'], o.stepTitle));
                }
                else{
                    this.steps = _.filter(this.steps, o => o.stepTitle != 'sourceFactors');
                    // this.steps = _.filter(this.rawSteps, o => o.stepTitle != 'sourceFactors');
                }
            }

        },
        selectUnit(){
            this.updateSourceFactorOptions();
            this.forceUpdate();
        },
        getDateRange(startDate, endDate){
            let startYear = moment(startDate).year();
            let endYear = moment(endDate).year();
            if(moment().isBetween(startDate, endDate)){
                endYear = this.$t('ongoing');
            }
            return `${startYear} - ${endYear}`;
        },
        nextStep(){
            if (this.activeStep++ > this.steps.length-2) this.activeStep = 0;
            if(this.steps[this.activeStep].stepTitle == 'emissionFactors') {
                this.getEmissionLibraries();
            } 
        },
        getEmissionLibraries(){
            this.isEmissionsLoaded = false;
            this.$Progress.start();
            let item = {
                locations: this.editedItem.locations, 
                scopeGroupId: this.scopeGroups[this.editedItem.scopeGroup].id,
                sourceTypeGroupId: this.editedItem.sourceTypeGroup,
                sourceTypeId: this.editedItem.sourceType,
                unitId: this.editedItem.unit
            }
            return this.axios.post('/getRelatedEmissionLibraries', item).then(({data}) => {
                this.emissionLibraries = _.uniqBy(_.map(_.get(data, 'emissionLibraryContent'), o => {
                    return {value:o.emission_library_id, text:this.$t(o.name) }
                }), 'value')
                this.emissionLibraryContents = _.get(data, 'emissionLibraryContent');
                this.emissionLibraries = [{value: null, text:this.$t('Custom')}, ...this.emissionLibraries];
                this.relatedSites = _.sortBy(data.locationInfo, 'siteName');
                this.editedItem.exampleSiteId = _.get(_.first(this.relatedSites), 'siteId');
                this.setExampleLibrary();
                this.$Progress.finish();
                this.isEmissionsLoaded = true;
            });
        },
        setExampleLibrary(){
            if(_.isNull(this.editedItem.exampleSiteId)){
                this.editedItem.exampleSiteId = _.get(_.first(this.relatedSites), 'siteId');
            }
            let selectedSite = _.find(this.relatedSites, o => o.siteId == this.editedItem.exampleSiteId);
            this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                return(
                    o.emission_library_id == this.editedItem.emissionSource 
                    && o.region_id == selectedSite.regionId
                    && o.sector_id == selectedSite.sectorId
                    && o.unit_id == this.editedItem.unit
                )
            });
            if(this.emissionLibraryExample == undefined){
                this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                    return(
                        o.emission_library_id == this.editedItem.emissionSource 
                        && o.region_id == null 
                        && o.country_id == selectedSite.countryId
                        && o.sector_id == selectedSite.sectorId
                        && o.unit_id == this.editedItem.unit
                    )
                });
            }
            if(this.emissionLibraryExample == undefined){
                this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                    return(
                        o.emission_library_id == this.editedItem.emissionSource 
                        && o.country_id == null
                        && o.sector_id == selectedSite.sectorId
                        && o.unit_id == this.editedItem.unit
                    )
                });
            }
            if(this.emissionLibraryExample == undefined){
                this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                    return(
                        o.emission_library_id == this.editedItem.emissionSource 
                        && o.region_id == null 
                        && o.country_id == selectedSite.countryId
                        && o.sector_id == null
                        && o.unit_id == this.editedItem.unit
                    )
                });
            }
            if(this.emissionLibraryExample == undefined){
                this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                    return(
                        o.emission_library_id == this.editedItem.emissionSource 
                        && o.region_id == selectedSite.regionId
                        && o.sector_id == null
                        && o.unit_id == this.editedItem.unit
                    )
                });
            }
            if(this.emissionLibraryExample == undefined){
                this.emissionLibraryExample = _.find(this.emissionLibraryContents, o => {
                    return(
                        o.emission_library_id == this.editedItem.emissionSource 
                        && o.country_id == null
                        && o.sector_id ==  null
                        && o.unit_id == this.editedItem.unit
                    )
                });
            }
            this.emissionLibraryData = _.map(this.emissionTypes, emissionKey => {
                return {name:emissionKey.name, start:this.$t('ongoing'), emissionFactor:this.emissionLibraryExample[emissionKey.name]}
            });
            this.emissionLocationInfo = this.regionMap[this.emissionLibraryExample.region_id];
            
        },
        selectEmissionLibrary(){
            if(!_.isNull(this.editedItem.emissionSource)) {
                this.setExampleLibrary();
            }
            this.forceUpdate();
        },
        prevStep(){
            if (this.activeStep != 0) this.activeStep--;
        },
        isLastStep(){
            return this.activeStep < this.steps.length-1;
        },
        checkIfButtonDisabled(){
            if(this.activeStep == 0) {
                return _.isEmpty(_.filter(this.scopeGroups, o => { return o.isSelected == true }));
            } else {
                return this.isValid(this.activeStep);
            }
        },
        isValid(step) {
            if(this.steps[step].stepTitle == 'defineSources') {
                this.errors[step].sourceName = !this.editedItem.name;
                this.errors[step].sourceType = !this.editedItem.sourceType;
                this.errors[step].unit = !this.editedItem.unit;                
                //this.errors[step].validFrom = !this.editedItem.validFrom;
                if(_.isEmpty(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups)){
                    _.remove(this.errors[step], 'sourceTypeGroup')
                } else {
                    this.errors[step].sourceTypeGroup = !this.editedItem.sourceTypeGroup;
                }

                let validation = true;
                for (let key in this.errors[step]) {
                    validation &= !this.errors[step][key];
                }
                return validation == 0 ? true : false;
            } else if (this.steps[step].stepTitle == 'assignLocations') {
                this.errors[step].locations = _.isEmpty(this.editedItem.locations);
                return this.errors[step].locations;
            } else if (this.steps[step].stepTitle == 'emissionFactors') {
                //return _.isEmpty(_.filter(this.editedItem.emissionFactors, o => o != ''));
                return false
            } else {
                return false;
            }
        },
        closeUpdateConfirmationDialogs() {
            this.duplicateSourceModal = false;
            this.convertUnitsModal = false;
            this.inactivateSourceModal = false;
        },
        openSourceDeleteModal() {
            this.$refs.confirmSourceDelete.show();
        },
        closeDeleteModal(){
            this.$refs.confirmSourceDelete.hide();
        },
        prepareData(data){
            this.unitMap = {};

            this.unitList = _.map(_.get(data, 'units'), nData=>{
                this.unitMap[nData.id] = _.get(nData, 'name');
                this.unitTypeMap.name[this.unitMap[nData.id]] = _.get(_.get(nData, 'cols'), 'type');
                this.unitTypeMap.id[nData.id] = _.get(_.get(nData, 'cols'), 'type');
                return {
                    id: nData.id,
                    label: this.unitMap[nData.id] 
                }
            });


            this.scopeGroups = _.map(data.scopeGroups, scopeGroup => {
                let sourceGroupRel =  _.filter(scopeGroup.sourceTypeMap, o=> _.get(o, 'rel_type') == 'source-group')
                let sources = {};
                _.each(_.groupBy(sourceGroupRel, 'tag_2'), (rel,relId)=>{
                    sources[relId] = _.map(rel, 'rel_id');
                });
                return {...scopeGroup, isSelected:false, sourceTypes:sources}
            });

            this.sourceTypes = data.sourceTypes;
            this.emissionTypes = data.emissionTypes;
            this.emissionLocationInfo = _.first(this.regionMap);
        },
        init() {
            this.isLoaded = false;
            this.$Progress.start();

            return this.axios.get('/sources').then(({data}) => {
                this.prepareData(data);
                this.$Progress.finish();
                this.isLoaded = true;
            });
        }
    },
    created() {
        if(this.isMaster(this.$store.state.user.customerId)){
            this.rawSteps.push(
                {
                    stepTitle: 'sourceDesign',
                    editStepTitle: 'editSourceDesign',
                    stepSubTitle: 'sourceDesign',
                    editStepSubTitle: 'editSourceDesign',
                }
            )
        }
        
        this.steps = _.clone(this.rawSteps);

    },
}
</script>

<style scoped lang="scss">

// .confirm-dialog .close {
//     position: absolute;
//     right: 1rem;
// }

.modal-dialog {
    .stepSubTitle {
        font-size: 2em;
        font-weight: bold;
    }
    .formTitle {
        font-weight:bold;
        font-size: .9em;
    }
    
    .card {
        border: 1px solid rgba(0,0,0,0.3);
        padding: 10px;
        padding-bottom: 0;
    }
    .card-body {
        padding: .75rem;
    }
    .card-text {
        margin-top: 20px;
        font-weight: bold;
        font-size: 1em;
    }
    .modal-button {
        border: none;
        padding: 10px 20px;
    }
    .section-line {
        width: 75%;
        padding-bottom:10px;
        border-bottom: 1px solid #ddd;
    }
    .add-custom-factor-btn {
        background-color:#4129A8;
        border-radius: 15px;
        font-size: .7em;
        box-shadow: none;
    }
    .is-design-active{
        background-color: rgba(251, 127, 127, 0.164);
    }
    .line-text {
        line-height: 1em;
        position: relative;
        outline: 0;
        border: 0;
        color: #022b49;
        text-align: center;
        height: 1.5em;
        opacity: 1;
        &:before {
            content: '';
            background: #022b49;
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 1px;
        }
        &:after {
            content: attr(data-content);
            position: relative;
            display: inline-block;
            color: #022b49;

            padding: 0 1.5em;
            line-height: 1.5em;
            // this is really the only tricky part, you need to specify the background color of the container element...
            color: #022b49;
            background-color: #fcfcfa;
        }
    }
    .delete-button {
        background-color: #d04d4d;
        border: none;
        box-shadow: none;
    }
    .is-invalid {
        border-color: #F14079 !important;
    }
    
}

/deep/ .modal-dialog {
    .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff;
        border: .5px solid #022b49;
        background-color: #41B884;
    }
    .custom-control-input ~ .custom-control-label::before {
        color: #022b49;
        border: .5px solid #022b49;
        background-color: #fff;
    }
    .custom-control-input:focus ~ .custom-control-label::before {
        box-shadow: none;
    }
    .form-control {
        color: #022b49 !important;
        font-size: .9em !important;
        border-radius: 10px;
    }
    .form-control::placeholder {
        color: #AAABB9 !important;
        font-size: .8em !important;
    }
    .emission-library-factor::placeholder {
        color: #022b49 !important;
        font-weight: bold !important;
    }
    .emission-library-factor:focus {
        box-shadow: none;
        border-color:#e9ecef;
    }
    .custom-select {
        color: #022b49 !important;
        font-size: .9em !important;
        border-radius: 10px;
        box-shadow: none;
    }
    .el-input__inner {
        border-radius: 10px;
    }
    .el-date-editor::placeholder {
        color: #AAABB9 !important;
        font-size: .8em !important;
    }
    

    .el-step.is-vertical .el-step__title {
        font-size: 0.8em;
    }

    .el-step.is-vertical .el-step__title.is-success {
        color: #41B884;
    }

    .el-step.is-vertical .el-step__title.is-process {
        color: #4129A8;
    }

    .el-step.is-vertical .el-step__title.is-wait {
        color: #AAABB9;
    }

    .el-step__head.is-success {
        color: #fff;
        border-color:#41B884;
        .el-step__icon {
            background-color: #41B884;
        }
    }

    .el-step__head.is-process {
        color: #fff;
        border-color:#4129A8;
        .el-step__icon {
            background-color: #4129A8;
        }
    }

    .el-step__head.is-wait {
        color: #fff;
        border-color:#AAABB9;
        .el-step__icon {
            background-color: #AAABB9;
        }
    }

    .masked-input-custom {
        color: #022b49 !important;
        font-size: .9em !important;
        border-radius: 10px;
        border: 1px solid #AAABB9 !important;
        padding: 5px 10px;
    }
    .masked-input-custom::placeholder {
        color: #AAABB9 !important;
        font-size: .8em !important;
    }
    .masked-input-custom:focus {
        color: #022b49 !important;
        border: 1px solid #AAABB9 !important;
        outline: none;
    }
}

/deep/ .emission-th {
    width: 10em;
    color:#022b49;
    border-top:none;
    font-size: .9em;
}
/deep/ .emission-td {
    font-size: 0.875em;
    text-align:left;
    color: #212529;
}

.is-selected {
    box-shadow: 0 0 0 3px #41B884;
}
.modal-button {
    border-radius: 10px;
}
.modal-button:focus{
    outline: none;
}
</style>


<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "Source": "Kaynak",
            "Activity":	"Aktivite",
            "Type":	"Tür",
            "Location":	"Lokasyon",
            "disableYear": "Pasifleştirme Tarihi",
            "selectActivity": "Aktivite Seç",
            "defineSources": "Kaynakları Belirle",
            "assignLocations": "Lokasyon Atama",
            "emissionFactors": "Emisyon Faktörleri",
            "selectActivityTitle": "Kaynakla ilgili ne tür bir aktivite var?",
            "defineSourcesTitle": "Kaynak Tanımla",
            "emissionFactorsTitle": "Sera Gazı Emisyonu hesaplama parametreleri",
            "purchasedEnergy": "Satın Alınan Enerji",
            "stationaryCombustion": "Durağan Yakma Emisyonları",
            "companyVehicles": "Şirket Araçları",
            "employeeCommuting": "Personel Ulaşım",
            "businessTravel": "İş Seyahati",
            "wasteGeneratedInOps": "Operasyonlarda Üretilen Atık",
            "sourceName": "Kaynak İsmi",
            "writeSourceName": "Kaynak ismi yazınız",
            "writeSourceInfo": "Kaynak bilgisi yazınız",
            "disposalMethod": "İmha Etme Yöntemi",
            "vehicleType": "Araç Tipi",
            "transportMethod": "Ulaşım Yöntemi",
            "type": "Tip",
            "unit": "Birim",
            "validFrom": "Geçerlilik Tarihi",
            "calculationMethod": "Hesaplama Yöntemi",
            "emissionFactorSource": "Emisyon Faktörü Kaynağı",
            "source": "Kaynak",
            "activity": "Aktivite",
            "enabled": "Aktif",
            "greenhouseGas": "Sera Gazı",
            "start": "Başlangıç",
            "emissionFactor": "Emisyon Faktörü",
            "deleteConfirmTitle": "Kaynağı silmek istediğinize emin misiniz?",
            "deleteConfirmText": "Onayladığınızda, bu kaynak ve veriler kalıcı olarak silinecek ve kurtarılamayacak.",
            "addCustomFactor": "Özel katsayı ekle",
            "hazardous": "Tehlikeli",
            "sourceDesign": "Kaynak Dizaynı",
            "editSourceDesign": "Kaynak Dizaynı Düzenle",
            "header": "Başlık",
            "required": "Zorunlu",
            "editable": "Düzenlenebilir",
            "longProcessNotification": "Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.",
            "normalizationType": "Hedef Normalizasyon Parametresi",
            "area": "Alan",
            "person": "Kişi Sayısı",
            "Custom": "Özel Emisyon Faktörleri",
            "ongoing": "Devam Ediyor",
            "sourceInfoLoading": "Kaynak Bilgileri Yükleniyor...",
            "emissionInfoNotification": "Emisyon değerleri ülke, bölge ve sektöre göre değişkenlik göstermektedir",
            "duplicateSourceModalTitle": "Kaynak Tanımında Değişiklik",
            "duplicateSourceModalText": "Yapılan değişiklikler bu kaynak için girilmiş olan verilerde değişiklik yapılmasına neden olabilir. Nasıl devam etmek istersiniz?",
            "duplicateSourceBtn": "Yeni bir kaynak yarat",
            "convertExistingSourceBtn": "Mevcut Kaynağı Değiştir",
            "inactivateSourceModalTitle": "Eski Kaynağı Pasifleştirmek",
            "inactivateSourceModalText": "Yapılan değişiklerle yeni bir kaynak oluşturup eski halini pasif kaynaklar altına taşımak istediğinize emin misiniz?",
            "convertUnitsModalTitle": "Mevcut Kaynağı Değiştir",
            "convertUnitsModalText": "Kaynak için daha önceden girilen verileri yeni seçimlere göre dönüştürmek istediğinize emin misiniz?",
            "invalidUnits": "Seçilen birimler arası dönüşüm yapılamadığından bu işlemi gerçekleştiremiyoruz."
        },
        "en": {
            "Source": "Source",
            "Activity":	"Activity",
            "Type":	"Type",
            "Location":	"Location",
            "disableYear": "Inactivation Year",
            "selectActivity": "Select Activity",
            "defineSources": "Define Sources",
            "assignLocations": "Assign Locations",
            "emissionFactors": "Emission Factors",
            "selectActivityTitle": "What kind of activity is related to the source?",
            "defineSourcesTitle": "Define Source",
            "emissionFactorsTitle": "Greenhouse Gas Emission calculation parameters",
            "next": "Next",
            "back": "Back",
            "purchasedEnergy": "Purchased Energy",
            "stationaryCombustion": "Stationary Combustion",
            "companyVehicles": "Company Vehicles",
            "employeeCommuting": "Employee Commuting",
            "businessTravel": "Business Travel",
            "wasteGeneratedInOps": "Waste Generated in Operations",
            "sourceName": "Source Name",
            "writeSourceName": "Write source name",
            "writeSourceInfo": "Write source information",
            "disposalMethod": "Disposal Method",
            "vehicleType": "Vehicle Type",
            "transportMethod": "Transport Method",
            "type": "Type",
            "unit": "Unit",
            "validFrom": "Valid From",
            "calculationMethod": "Calculation Method",
            "emissionFactorSource": "Emission Factor Source",
            "source": "Source",
            "activity": "Activity",
            "enabled": "Enabled",
            "greenhouseGas": "Greenhouse Gas",
            "start": "Start",
            "emissionFactor": "Emission Factor",
            "deleteConfirmTitle": "Do you want to delete this source?",
            "deleteConfirmText": "Once you confirm, this source and data will be permanently deleted and cannot be recovered.",
            "addCustomFactor": "Add Custom Factor",
            "hazardous": "Hazardous",
            "sourceDesign": "Source Design",
            "editSourceDesign": "Edit Source Design",
            "header": "Header",
            "required": "Required",
            "editable": "Editable",
            "longProcessNotification": "This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.",
            "normalizationType": "Intensity Target Parameter",
            "area": "Area",
            "person": "Number of Occupant",
            "Custom": "Custom Emission Factors",
            "ongoing": "Ongoing",
            "sourceInfoLoading": "Loading Source Information...",
            "emissionInfoNotification": "Emission values vary according to the country, region and sector",
            "duplicateSourceModalTitle": "Change in Source Definition",
            "duplicateSourceModalText": "Changes made may cause changes to the data entered for this resource. How would you like to continue?",
            "duplicateSourceBtn": "Create new source",
            "convertExistingSourceBtn": "Change this source",
            "inactivateSourceModalTitle": "Deactivate Existing Source",
            "inactivateSourceModalText": "Are you sure you want to create a new source according to the changes and deactivate existing source?",
            "convertUnitsModalTitle": "Change this source",
            "convertUnitsModalText": "Are you sure you want to transform the previously entered data according to the changes?",
            "invalidUnits": "We cannot complete this operation due to unit conversion cannot be performed between selected units."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/modals/CreateSource.vue